import template from './feature_roles_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class FeaturesRolesHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class FeaturesRolesHelpPageClass
{
	constructor (bindings)
	{
		this.viewModel = new FeaturesRolesHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'FeaturesRolesHelp',
	dialog_class: FeaturesRolesHelpPageClass,
	template: template,
	template_filename: 'translation/dialogs/feature_roles_help',
	provider: 'ps'
};
